import { createAction, createSlice } from '@reduxjs/toolkit';
import {
  SCREEN_COMMAND_RESULT,
  VEHICLE_TAKE_OVER_INFO,
} from '../actions/common';
enum RemoteCommandType {
  REMOTE_CONTROL_POWER_OFF = '远程下电',
  REMOTE_CONTROL_POWER_REBOOT = '断电重启',
  REMOTE_DRIVE_ENTER_TAKE_OVER = '进入接管',
  REMOTE_DRIVE_EXIT_TAKE_OVER = '退出接管',
}

export enum MessageState {
  INIT = 'INIT',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export const actionClearCommandRes = createAction('actionClearCommandRes');
const initState = {
  vehicleName: null,
  remoteCommandType: null,
  messageState: null,
  operationMessage: null,
  failInfo: null,
  requestTime: null,
};
const commandRes = createSlice({
  name: 'commandRes',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SCREEN_COMMAND_RESULT, (state, action: any) => {
        const res = action.payload;
        const {
          vehicleName,
          remoteCommandType,
          messageState,
          operationMessage,
          failInfo,
          requestTime,
        } = res?.data || {};
        state.vehicleName = vehicleName;
        state.remoteCommandType = remoteCommandType;
        state.messageState = messageState;
        state.operationMessage = operationMessage;
        state.failInfo = failInfo;
        state.requestTime = requestTime;
      })
      .addCase(VEHICLE_TAKE_OVER_INFO, (state: any, action: any) => {
        const res = action.payload;
        const {
          vehicleName,
          remoteCommandType,
          requestTime,
        } = res?.data || {};
        state.vehicleName = vehicleName;
        state.remoteCommandType = remoteCommandType;
        state.messageState = MessageState.SUCCESS;
        state.requestTime = Date.now();
      })
      .addCase(actionClearCommandRes, (state, action: any) => {
        state.requestTime = null;
        state.messageState = null;
        state.vehicleName = null;
        state.remoteCommandType = null;
        state.operationMessage = null;
        state.failInfo = null;
      });
  },
});

export default commandRes.reducer;
